import api from "../../../utils/api";
import type { Lead } from "./leadsService";

// ============================================================================
// CRM — Meta Lead Ads integration — frontend service.
// Talks to the torre-de-control-api crmMetaLeads module:
//   • status   (authed): GET  /crm/meta/status      — is the webhook configured?
//   • backfill (authed): POST /crm/meta/backfill     — import one leadgen_id
// The actual lead intake is a server-to-server webhook Meta calls directly
// (POST /crm/meta/webhooks/leadgen); those leads land in `crm_leads` and show
// up in the Leads section automatically (source = "meta_ads").
// ============================================================================

export interface MetaIntegrationStatus {
  /** True only when BOTH the app secret and a page token are set. */
  configured: boolean;
  graphVersion: string;
  /** Path appended to the API base to form the webhook URL. */
  webhookPath: string;
  appSecretSet: boolean;
  verifyTokenSet: boolean;
  pageTokenSet: boolean;
}

/** The full webhook URL to register inside Meta (API base + webhook path). */
export function metaWebhookUrl(status: MetaIntegrationStatus): string {
  const base = (api.defaults.baseURL || "").replace(/\/+$/, "");
  return `${base}${status.webhookPath}`;
}

export async function fetchMetaStatus(): Promise<MetaIntegrationStatus> {
  const res = await api.get("/crm/meta/status");
  return res.data?.data as MetaIntegrationStatus;
}

/** Manually import a single Meta leadgen_id (testing / migration / retry). */
export async function backfillMetaLead(
  leadgenId: string,
  pageId?: string,
): Promise<{ created: boolean; lead?: Lead; skipped?: string }> {
  const res = await api.post("/crm/meta/backfill", {
    leadgenId,
    ...(pageId ? { pageId } : {}),
  });
  const body = res.data ?? {};
  // 201 → { data: <lead> } ; 200 → { data: { skipped, leadgenId } }
  if (body.data && body.data.id) {
    return { created: true, lead: body.data as Lead };
  }
  return { created: false, skipped: body.data?.skipped || "duplicate" };
}
